const HAS_MOUSE_EFFECTS = {
  button: {
    primary: 'primary',
    quaternary: 'quaternary',
  },
  label: {
    secondary: 'secondary',
  },
};

export { HAS_MOUSE_EFFECTS };
